class ThemeBreadcrumb extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this._current = this.querySelector('[data-breadcrumb-current]');
    if (!this._current) return;

    this._onResize = this._handleResize.bind(this);
    window.addEventListener('resize', this._onResize, { passive: true });
    this._syncTitle();
  }

  disconnectedCallback() {
    if (!this._bound) return;

    window.removeEventListener('resize', this._onResize);
    this._bound = false;
  }

  _handleResize() {
    cancelAnimationFrame(this._frame);
    this._frame = requestAnimationFrame(() => this._syncTitle());
  }

  _syncTitle() {
    if (!this._current) return;

    const fullTitle = this._current.getAttribute('data-full-title') || this._current.textContent.trim();
    const isTruncated = this._current.scrollWidth > this._current.clientWidth + 1;

    if (isTruncated && fullTitle) {
      this._current.setAttribute('title', fullTitle);
    } else {
      this._current.removeAttribute('title');
    }
  }
}

if (!customElements.get('theme-breadcrumb')) {
  customElements.define('theme-breadcrumb', ThemeBreadcrumb);
}
